export default __webpack_public_path__ + "static/media/DoubleArrowDown.79655a3f.svg";